import * as React from 'react';
import { Link } from 'react-router-dom';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Divider } from '@daedalus/atlas/Divider';
interface Props {
  isActive: boolean;
  preFixIcon: React.ReactNode;
  suffixIcon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void | undefined;
  to?: string;
}
const ItemContent = /*#__PURE__*/styled('div')({
  name: "ItemContent",
  class: "i1s28mzl",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => Link;
const SideMenuLink = /*#__PURE__*/styled(_exp2())({
  name: "SideMenuLink",
  class: "s1ogryf9",
  propsAsIs: true
});
const Label = /*#__PURE__*/styled('div')({
  name: "Label",
  class: "l167behp",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "ilc6lcb",
  propsAsIs: false
});
export const AccountSideMenuItem = ({
  isActive,
  onClick,
  to,
  preFixIcon,
  suffixIcon,
  children
}: Props) => <li>
    <Divider />
    <SideMenuLink to={to || ''} onClick={onClick} className={cx(isActive && 'isActive')}>
      <Label>
        <IconWrapper>{preFixIcon}</IconWrapper>
        <ItemContent>{children}</ItemContent>
      </Label>
      {suffixIcon}
    </SideMenuLink>
  </li>;

require("./AccountSideMenuItem.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AccountSideMenuItem.tsx");